import logging from '../logging';
import Signal from './signal';

export const log = logging('render-loop');


export default class RenderLoop {
    private needsUpdate: boolean = true;
    private render: () => void;
    private running: boolean = false;

    public onBeforeRender = new Signal('onBeforeRender', 'control-flow');

    constructor(render: () => void) {
        this.render = render;
    }

    start() {
        if (this.running) return;

        this.running = true;
        const animate = () => {
            if (this.running) {
                requestAnimationFrame(animate);
                if (this.needsUpdate) {
                    this.onBeforeRender.trigger();
                    try {
                        this.render();
                    } catch (error) {
                        log.error(error);
                    }
                    this.needsUpdate = false;
                }
            }
        };
        animate();
    }

    stop() {
        this.running = false;
    }

    update = () => {
        this.needsUpdate = true;
    }
}
